// React
import React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// Components
import { Hero } from 'components/Hero';
import { FluidSection } from 'components/FluidSection/index';
import { Content } from 'components/Content/index';
import { List } from 'components/List';
import { VideoModal } from 'components/VideoModal';
import { Calendar } from 'components/Calendar';
import FlatButton from 'material-ui/FlatButton';
import { Button } from 'components/Button/index';
import ServiceDetailView from './ServiceDetailView';
import BookingSelectionView from './BookingSelectionView';
import BookingFormView from './BookingFormView';

// Others
import { constants } from 'constants/index';

import SwipeableViews from 'react-swipeable-views';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import OverlapPanel from '../../../components/OverlapPanel/OverlapPanel';
import FlexEnd from '../../../components/Positioners/FlexEnd';
import { LogoAvatar } from 'components';
const moment = require('moment-timezone');

class ServiceSalesFlow extends React.Component {

    constructor () {
        super();
        this.state = {
            viewIndex: 0,
            heroOrientation: 'row',
            showModal: false,
            randomCards: null,
            showCalendar: false,
            heroHeight: '250px',
            buttonVisible: true,
            mainHeroButtonText: 'View Availability',
            mainHeroButtonIcon: '',
            provider: null,
            service: null,
            company: null,
            calendarFlexStyle: {},
            booking: null,
            companyServiceProvidersLoaded: false,
            width: 0,
            height: 0
        };

        this.handleOpenVideoModal = this.handleOpenVideoModal.bind(this);
    }

    // ########## LIFE CYCLE HOOKS ############## //

        componentWillMount() {
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);
            // this.setState(this.getNRandomNumbers(0, props.experts.length-1, 3)
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.updateWindowDimensions);
        }
        
        componentDidMount(){
            // Go to the top of the page on load
            document.getElementById('top').scrollIntoView();
            
            // Recive window dimentions
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);

            this.props.getDBProviders();
            this.props.getDBServices();
            this.props.getDBProviderCompanies();
            this.props.getDBServiceCategories();
            this.props.getDBServiceModules();
        }
        
        componentWillReceiveProps(nextProps) {
            this.getProviderCompanyService(nextProps);
        }

    // ########################################### //

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
        this.props.updateWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
    }

    handleChangeViewIndex = (index) => {
        if (index === 1) {
            this.setState({
                viewIndex: index,
                showCalendar: true,
                heroHeight: '250px',
                mainHeroButtonText: null,
                mainHeroButtonIcon: null,
                heroOrientation: 'row'
            });
        } else if (index === 0){
            this.setState({
                viewIndex: index,
                showCalendar: false,
                heroHeight: '250px',
                mainHeroButtonText: 'Book Your Consultation',
                mainHeroButtonIcon: null,
                heroOrientation: 'row'
            });
        } else if (index === 2){
            this.setState({
                viewIndex: index,
                showCalendar: false,
                heroHeight: '0px',
                mainHeroButtonText: 'Book Your Consultation',
                mainHeroButtonIcon: null,
                heroOrientation: 'row'
            });
        }
    }

    getProviderCompanyService = (props) => {
        if (props.providers && props.services && props.companies) {
            return props.providers.map((provider)=> {
                // console.log(`%c${JSON.stringify(provider.uid)} ${JSON.stringify(props.match.params.id)}`,'color: deeppink');
                return props.services.map(service => {
                    if (service._id === props.serviceId) {
                        return props.companies.map(company => {
                            if (company._id === service.company) {
                                if (provider.uid === service.provider) {
                                    // console.log('MATCH FOUND FOR PROVIDER');
                                    // console.log('COMPANY SERVICE PROVIDER', company, service, provider);
                                    if (!this.state.companyServiceProvidersLoaded){
                                        this.setState({
                                            provider,
                                            service,
                                            company,
                                            companyServiceProvidersLoaded: true
                                        }, ()=>{
                                            console.log('Getting calendar from ServiceSalesFlow', provider.SBMId, service.SBMId);
                                            props.getCalendar(provider.SBMId, service.SBMId);
                                        })
                                    }
                                }
                                return;
                            }
                        })
                    }
                })
            });
        } else {
            // console.error('NO EXPERT FOUND at getExpert()');
            return null;
        }
    }

    handleOpenVideoModal = () => {
        this.setState({ showModal: true });
    }

    handleCloseVideoModal = () => {
        this.setState({ showModal: false });
        // console.log('CLOSE VIDEO HAS RUN');
    }

    // getDateToday = () => {
    //     let today = new Date();
    //     let dd = today.getDate();
    //     let mm = today.getMonth()+1; //January is 0!

    //     const yyyy = today.getFullYear();
    //     if(dd<10){
    //         dd='0'+dd;
    //     }
    //     if(mm<10){
    //         mm='0'+mm;
    //     }
    //     const date = mm+'-'+dd+'-'+yyyy;

    //     return date;
    // }

    handleConfirmBooking = (values, activePeriodKey, cb) => {
        // console.log('Now running handle confirm booking...');
        // console.log('ACTIVE PERIOD @ HANDLE CONFRIM BOOKING', activePeriodKey);
        
        return new Promise(async (resolve, reject) => {
            const { serviceId, providerId, date, time, thisWeekStartDate } = this.state.booking;
            
            const clientData = {
                name: `${values.firstName} ${values.lastName}`,
                email: values.email,
                phone: values.phone,
                message: values.notes,
                client_time_offset: 0
            };
            
            // DONT DELETE!!!!
            // const fieldsArray = await this.props.getAdditionalFields(serviceId);
            
            // !!!!! DONT DELETE THIS - GIVES THE IDs FOR ALL ADDITIONAL FIELDS
            // console.log('%cADDITIONAL FIELDS','color: gold');
            // console.log(fieldsArray);

            const additionalData = {
                // 'f9da2957715c2fe2391066a54353c477': values.notes,
                // '199fb043ef82cbd044d86665f5f84144': values.phone
                '61b06abc1fed07fc9a14e6c83e61a821': moment(date, 'YYYY-MM-DD').format('MMMM Do, YYYY'), // Appointment Date
                '9f10afef7f506749032d6c22f048d762': this.state.service._id, // ServiceId
                'ded3bb26bf6ec831b4408ca1962f3e93': moment(time, 'HH:mm:ss').format('h:mm a'), // Appointment Time
                '77f6b6926ba83ab72889940dbf7e6ae7': moment.tz.guess(),
            }
            
            // console.log('CLIENT TZ', moment.tz.guess());
            
            // BOOK APPOINTMENT
            this.props.bookConsult({
                userId: this.props.userId,
                serviceId, 
                providerId, 
                startDate: date, 
                startTime: time, 
                clientData, // IS THIS BEING USED?  IF NOT, DELETE
                additionalData,
                reason: values.notes,
                clientId: (this.props.userData) ? this.props.userData.SBMClientId : null, 
                cb,
                providerKey: this.state.service.provider, 
                serviceKey: this.state.service._id, 
                activePeriodKey
            })
                .then((dbRef, bookingData) => {
                    if (bookingData.confirmationData) {
                        // console.log('Calling callback...');
                        cb(bookingData);
                        
                        resolve(bookingData);
                        
                        this.props.notifyUser({
                            message: 'Your booking has been confirmed and will be available in your dashboard.',
                            textColor: 'white'
                        })
                        
                        this.props.getDBServices();
                        this.props.getDBProviders();
                        
                        this.props.getClientData(this.props.userId, ()=>{
                            this.props.filterServicesByStatus(this.props.userId); // TEST
                        }); // TEST
                        
                        this.props.setSelectedService(this.props.booking.service); //temp TEST
            
                        // THIS CALL IS IMPORTANT FOR LOADING BOOKINGS DO NOT REMOVE
                        this.props.loadUpcomingDbBookings({
                            userId: this.props.userId, 
                            serviceId: this.props.booking.service._id,
                            userType: 'client'
                        })
    
                        // Refresh the Calendar with new Calendar state
                        console.log('providerId, serviceId for getCalendar', providerId, serviceId);
                        
                        this.props.getCalendar(providerId, serviceId, thisWeekStartDate);
                    }
                    
                    // RESET CLIENT BOOKING STATE
                    this.setState({
                        booking: {}
                    });

                    // Stop listening for booking confirmation updates to the booking node
                    dbRef.off();
                })
                .catch(console.log)
        });
        
    }

    setBookingData = ({thisWeekStartDate, serviceId, providerId, time, date, index, selectedProviderData}) => {
        this.setState({
            booking: {
                thisWeekStartDate,
                serviceId,
                providerId,
                time,
                date,
                index,
                selectedProviderData
            }
        }, (nextState)=>{
            
            document.getElementById('top').scrollIntoView();
            
            this.handleChangeViewIndex(2);

            // Load Selection Data into Gloabl State Storage
            this.props.setBookingProvider({...selectedProviderData, providerId});
            this.props.setBookingDetails({date, time});
            this.props.setBookingService(this.state.service);
        })
    }

    render(){
        console.log( 'width in SSF for Hero', this.state.width)
        // const dateToday = this.getDateToday();
        const { provider, service, company } = this.state;
        let displayView = {display:'none'}

        return (
            <div className="ServiceSalesFlowMainDiv">
                { provider && service && company &&
                <div className="ServiceSalesFlowHeroDiv">
                    <Hero
                        id="expertHero"
                        backgroundImageURL={service.coverPhotoURL}
                        tintOpacity='0.0'
                        logoAvatarSize={130}
                        flexPosition="flex-start"
                        avatarImageURL={provider.profilePhotoURL}
                        avatarLogoURL={company.logoURL}
                        height={200}
                        avatarClick
                    />
                    {/* { !this.state.showCalendar &&
                        <FlexEnd>
                            <OverlapPanel styles={{paddingTop: 25}}>
                                <Content bodyText={service.fullPrice / 100 + ' CDN'}/>
                                <Button
                                    onClick={() => this.handleChangeViewIndex(1)}
                                    alignButton={'center'}
                                    style={{marginBottom: 10,}}
                                    // style={ bottomRightMargins }
                                >
                                    Book & Purchase
                                </Button>
                            </OverlapPanel>
                        </FlexEnd>
                    } */}
                </div>
                    
                }
                { provider && service && company && this.props.serviceModules &&
                    <SwipeableViews
                        index={this.state.viewIndex}
                        onChangeIndex={this.handleChangeViewIndex}
                    >
                    {   this.state.viewIndex === 0 &&
                        <ServiceDetailView 
                            // style={{display:'none'}}
                            serviceModules={ this.props.serviceModules }
                            service={ service }
                            provider={ provider }
                            company={ company }
                            user={ this.props.userData }
                            onChangeViewIndex={ this.handleChangeViewIndex }
                        />
                    }
                    {   this.state.viewIndex === 1 &&
                        <BookingSelectionView 
                            onChangeViewIndex={ this.handleChangeViewIndex }
                            service={ service }
                            setBookingData={ this.setBookingData }
                        />
                    }
                    {   this.state.viewIndex === 2 &&
                        <BookingFormView
                          onChangeViewIndex={ this.handleChangeViewIndex }
                          onConfirmBooking={ this.handleConfirmBooking }
                          user={ this.props.userData }
                          provider={provider}
                          bookingData={ this.props.bookingData }
                          handleClose={ () => this.handleChangeViewIndex(1) }
                        />
                    }
                </SwipeableViews>
                }
            </div>
        );
    }
};


const mapStateToProps = ({provider, service, company, auth, client}) => {
    return {
        userData: client.clientData,
        userId: (auth.authData) ? auth.authData.id : null,
        providers: provider.providers,
        services: service.services,
        serviceCategories: service.categories,
        serviceModules: service.modules,
        companies: company.providerCompanies
    };
}

export default connect(mapStateToProps, actions)(ServiceSalesFlow);


// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ServiceSalesFlow/ServiceSalesFlow.jsx